export const formatNumber = (value: string | number, fixedNumber = false): string => {
    return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: fixedNumber ? 2 : 0,
    }).format(Number(value));
};

export const formatNumberPDF = (value: string | number, fixedNumber = false): string => {
    if (value && value !== 0) {
        return formatNumber(value, fixedNumber);
    }
    if (value === undefined) {
        return '';
    }
    return '$ -';
};

export const parseValue = (value: string | number): number => {
    if (typeof value === 'string') {
        if (!value.includes(',')) {
            return Number(value.split('.').join(''));
        }
        return Number(value.split('.').join('').split(',').join('.'));
    }
    return Number(value);
};

export const formatDocument = (value: string | number): string => {
    return new Intl.NumberFormat('es-CO').format(Number(value));
};

export const leadingZeros = (value: string): boolean => value?.substring(0, 1) === '0';
